import { mapGetters, mapActions } from 'vuex'

var lessonFilterMixin = {
  data () {
    return {
      currentIndex: 0,
      defaultTitle: {
        language: '課程語言',
        category: '課程類別',
        level: '課程等級'
      }
    }
  },

  computed: {
    ...mapGetters([
      'lessonFilters',
      'lessonList'
    ]),

    lang () {
      return this.lessonFilters[this.currentIndex]
    },

    language () {
      if (!this.lessonFilters) return this.defaultTitle.language

      this.currentIndex = this.lessonFilters.map((el) => { return el.languageValue }).indexOf(this.lessonList.filter.language)
      return this.currentIndex > -1 ? this.lang.languageName : this.defaultTitle.language
    },

    category () {
      if (!this.lessonFilters[this.currentIndex]) return this.defaultTitle.category
      let idx = this.lang.categories.map((el) => { return el.Key }).indexOf(this.lessonList.filter.categoryId)
      return idx > -1 ? this.lang.categories[idx].Value : this.defaultTitle.category
    },

    level () {
      if (!this.lang) return this.defaultTitle.level

      let idx = this.lang.levels.indexOf(this.lessonList.filter.level)
      return idx > -1 ? this.lang.levels[idx] : this.defaultTitle.level
    }
  },

  methods: {
    ...mapActions([
      'getLessonFilters',
      'getLessonList'
    ]),

    updateLangIndex (index) {
      this.currentIndex = index

      this.updatePage({ language: this.lessonFilters[this.currentIndex].languageValue })
    },

    updatePage (params) {
      params.pageIndex = 1
      this.getLessonList(params)
    }
  }
}

export default lessonFilterMixin



// WEBPACK FOOTER //
// ./src/components/lessonFilterMixin.js